import { useState, useEffect, useCallback } from 'react';
import { API } from 'src/common/config/API';
import { processPlans, getButtonTextName } from '../utils/planHelpers';
import {
  resellerCard,
  resellerFeatures,
  planDescription
} from '../utils/constants';
import { changePlanText } from 'src/common/config/TextMessage';
import { normalizeName } from 'src/common/config/FunctionHelper';

export const usePlanProcessing = (
  currentPlanId: string,
  activePlanName: string,
  isNewPlan: string,
  selectedValue: string,
  subscriptionDetails: any
) => {
  const [pageLoad, setPageLoad] = useState(true);
  const [allPlan, setAllPlan] = useState<any[]>([]);
  const [cardData, setCardData] = useState<any[]>([]);
  const [featureListDetail, setFeatureListDetail] = useState<any[]>([]);
  const [featureListDetailKey, setFeatureListDetailKey] = useState<any[]>([]);
  const planVersion = subscriptionDetails?.planVersion;
  const featureList = useCallback(
    (plansDetails: any[], timeline = 'annually') => {
      let planMonth: any[] = [];
      let planYearly: any[] = [];
      plansDetails?.forEach((data: any) => {
        let featureListData: any[] = [];
        Object.keys(data.metadata || {})?.forEach((meta: any) => {
          if (meta.indexOf('feature_part') > -1) {
            let ArrayObject = JSON.parse(`${data.metadata[meta]}`);
            featureListData.push(JSON.parse(ArrayObject));
          }
        });
        let objectData = featureListData.flat();
        if (data?.recurring?.interval === 'month') planMonth.push(objectData);
        if (data?.recurring?.interval === 'year') planYearly.push(objectData);
      });
      planMonth.push(resellerFeatures);
      planYearly.push(resellerFeatures);
      setFeatureListDetail(timeline === 'monthly' ? planMonth : planYearly);
      setFeatureListDetailKey(
        timeline === 'monthly' ? planMonth[0] : planYearly[0]
      );
    },
    []
  );

  useEffect(() => {
    API.allPlan(
      API.EndPoint.allPlan,
      API.Method.get,
      undefined,
      {},
      (response) => {
        const responseDetails = { ...response.data };
        if (responseDetails.status === 'success') {
          const modifiedPlans = processPlans(responseDetails.plans);
          setAllPlan(modifiedPlans);
          featureList(modifiedPlans, selectedValue);
          setTimeout(() => setPageLoad(false), 2000);
        }
      }
    );
  }, []);

  useEffect(() => {
    if (allPlan.length > 0) {
      const isAnnually = selectedValue === 'annually';
      const filteredPlans = allPlan.filter(
        (d) =>
          (d?.metadata?.is_activated === true ||
            d?.metadata?.is_activated === 'true') &&
          d.recurring?.interval === (isAnnually ? 'year' : 'month')
      );
      const isAllV2Plan = !allPlan.some((d) => d?.metadata?.name?.toLowerCase()?.includes('free')) && allPlan.every((d) => d.metadata?.version === 'v2');
      const isOldPlan = planVersion == 'v1';
      const formattedData = filteredPlans.map((data, index) => {
        const matchesOldPlan = isOldPlan &&
          data?.recurring?.interval ===
            (subscriptionDetails?.interval === 'year' ? 'year' : 'month') &&
          activePlanName?.toLowerCase() === data?.metadata?.name?.toLowerCase();
        
        const isSubscribedOldPlan = isOldPlan &&
          activePlanName?.toLowerCase() === data?.metadata?.name?.toLowerCase();
        
        let btnText =
          data.id === currentPlanId
            ? changePlanText.subscribed
            : matchesOldPlan
            ? 'Upgrade'
            : getButtonTextName(
                data?.metadata?.display_name,
                data?.recurring?.interval,
                activePlanName,
                isNewPlan
              );

        if (isSubscribedOldPlan && data.id !== currentPlanId) {
          if (btnText === 'Switch to Monthly') {
            btnText = 'Upgrade to Monthly';
          } else if (btnText === 'Switch to Annual') {
            btnText = 'Upgrade to Annual';
          }
        }

        return {
          ...data,
          title: data.metadata.display_name,
          highlight: data.metadata.highlight ?? '',
          discountPercent: data.metadata.discount
            ? `Save ${data.metadata.discount}`
            : '',
          amount: isAnnually
            ? data.metadata.checktext ||
              `$${(data.unit_amount / 100).toFixed(2)}`
            : `$${(data.unit_amount / 100).toFixed(2)}`,
          discountedAmount: isAnnually
            ? `$${(data?.unit_amount / 12 / 100).toFixed(2)}`
            : undefined,
          subTitle:
            data.metadata.display_name === 'Free'
              ? '2 features only'
              : isAnnually
              ? 'Annually'
              : 'Monthly',
          subText: planDescription[normalizeName(data?.metadata?.name)] || '',
          btnText,
          isActivePlan: data.id === currentPlanId,
          isSubscribedOldPlan: isSubscribedOldPlan
        };
      });
      // Add reseller card
      // setCardData(formattedData);
      setCardData([...formattedData, resellerCard(selectedValue)]);
      featureList(allPlan, selectedValue);
    }
  }, [allPlan, selectedValue, currentPlanId, activePlanName, isNewPlan]);

  return {
    pageLoad,
    allPlan,
    cardData,
    featureListDetail,
    featureListDetailKey
  };
};
